(ns common.teams)

(defn account-teams [all-teams user-account]
  (->> all-teams
       (filter (fn [team]
                 (let [team-member-ids (->> team
                                            :team/members
                                            (map (fn [tm]
                                                   (or (:db/id tm) tm)))
                                            (set))]
                   (contains? team-member-ids (:db/id user-account)))))
       (map :db/id)
       (set)))

(defn resolve-account-teams [account-or-id all-teams]
  (let [a-id (:db/id account-or-id)
        account-id (cond a-id a-id
                         (number? account-or-id) account-or-id
                         :else nil)]
    (when account-id
      (->> all-teams
           (filterv (fn [team]
                      (let [team-member-ids (->> team
                                                 :team/members
                                                 (into
                                                  #{}
                                                  (map (fn [tm]
                                                         (or (:db/id tm) tm)))))]
                        (contains? team-member-ids account-id))))))))
